import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
import apiClient from "../../../../helpers/apiClient";

const SelectCategory = ({ setSelectedCategory, selectedCategory, t, setBags, setSeats }) => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState("");

    const fetchLocations = async () => {
        try {
            setLoading(true);
            const { data } = await apiClient.get("/api/car-category-v2/list?limit=200");

            if (data.data.length > 0) {
                const result = data.data.map((category) => ({
                    ...category,
                    value: String(category._id ?? category.id ?? ""),
                    label: category.categoryName,
                }));
                setCategories(result);
            }
        } catch (_error) {
            // console.error(t("fetchError"), error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (value) => {
        setSearchValue(value);
    };

    const handleCategoryChange = (value, option) => {
        setSelectedCategory({
            category: value,
            categoryName: option.label,
        });
        if (option.bags != null) {
            setBags(option.bags);
        }
        if (option.seats != null) {
            setSeats(option.seats);
        }
    };

    const filteredCategories = categories.filter((category) =>
        category.label.toLowerCase().includes(searchValue.toLowerCase()),
    );

    useEffect(() => {
        fetchLocations();
    }, []);

    return (
        <div>
            <p className="text-md font-medium mb-2">
                {t("car")} {t("category")}
            </p>
            <Select
                showSearch
                placeholder={`${t("car")} ${t("category")}`}
                optionFilterProp="children"
                onChange={handleCategoryChange}
                value={selectedCategory?.categoryName || undefined}
                className="w-full"
                options={filteredCategories}
                loading={loading}
                onSearch={handleSearch}
                filterOption={false}
            />
        </div>
    );
};

SelectCategory.propTypes = {
    setSelectedCategory: PropTypes.func.isRequired,
    selectedCategory: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    setBags: PropTypes.func.isRequired,
    setSeats: PropTypes.func.isRequired,
};

export default SelectCategory;
